import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APP_INSIGHTS_INSTRUMENTATION_KEY } from '../config';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: APP_INSIGHTS_INSTRUMENTATION_KEY,
  },
});

appInsights.loadAppInsights();

export default appInsights;
